import React, { useCallback } from 'react';
import FluentInput, { IFluentInputProps } from './FluentInput';
import { Maybe } from 'graphql/jsutils/Maybe';

interface IFluentNumericInputPropType extends Omit<IFluentInputProps, 'type'> {
  min?: number;
  max?: number;
  decimals: number;
}

const getStepValue = (decimals?: number) => {
  if (decimals === undefined || decimals === null || decimals < 0) {
    return undefined;
  }
  if (decimals === 0) return '1';
  return (1 / Math.pow(10, decimals)).toString();
};

const FluentNumericInput = ({ min, max, decimals, onChange, ...restProps }: IFluentNumericInputPropType) => {
  const stepValue = getStepValue(decimals);

  const onChangeHandler = useCallback(
    (inputValue: Maybe<string>) => {
      if (!onChange || inputValue === undefined || inputValue === null) return;

      const numValue = parseFloat(inputValue);

      // Handle invalid numbers
      if (inputValue !== '' && isNaN(numValue)) {
        // reject input
        return;
      }

      if (min !== undefined && numValue < min) {
        return;
      }

      if (max !== undefined && numValue > max) {
        return;
      }

      onChange(inputValue);
    },
    [onChange, min, max]
  );

  return <FluentInput type="Number" step={stepValue} onChange={onChangeHandler} {...restProps} />;
};

export default FluentNumericInput;
